import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useNumbersLayerContext } from 'pages/settings/pages/numbers/context/numbersLayerContext'

export const AddNumberLayout = () => {
  const { redirectToRoot } = useNumbersLayerContext()
  return (
    <StepsCommonLayout
      title='Add number'
      progressTitle='How do you want to add a number?'
      settingsStep={1}
      totalSteps={1}
      decreaseStep={() => {}}
      closeSetting={redirectToRoot}
    />
  )
}
